{
  "api": {
    "firebase": {
      "prod": {
        "projectId": "ms-cockpit-prod",
        "appId": "1:448418867926:web:c80d2e8fc83870151db777",
        "storageBucket": "ms-cockpit-prod.firebasestorage.app",
        "apiKey": "AIzaSyArdq6fUctv-eptp7FhZW2U1WR_9AqAYOQ",
        "authDomain": "ms-cockpit-prod.firebaseapp.com",
        "messagingSenderId": "448418867926",
        "databaseId": "ms-cockpit-db"
      },
      "dev": {
        "projectId": "ms-cockpit-dev",
        "appId": "1:571438196785:web:a4c7f2357ad1436eb9cd10",
        "storageBucket": "ms-cockpit-dev.firebasestorage.app",
        "apiKey": "AIzaSyA8HjX8yZt3WQ8KQxm0Gg6XApsXAtcAW7M",
        "authDomain": "ms-cockpit-dev.firebaseapp.com",
        "messagingSenderId": "571438196785",
        "databaseId": "ms-cockpit-db"
      }
    },
    "icure": {
      "prod": "https://api.icure.cloud",
      "dev": "https://api.icure.cloud"
    },
    "audit_service": {
      "prod": "https://audit.api.medispring.be",
      "dev": "https://audit.api-dev.medispring.be"
    }
  }
}
